import React from "react";
import incredibleImage1 from "../assets/images/7.jpg";
import incredibleImage2 from "../assets/images/8.jpg";
import incredibleImage3 from "../assets/images/9.jpg";
import incredibleImage4 from "../assets/images/10.png";
import IncredibleCard from "./IncredibleCard";

function Incredible() {
  const data = [
    {
      imageSrc: incredibleImage1,
      headingText: "KingSurvivor",

      subHeading: "Head",
    },
    {
      imageSrc: incredibleImage2,
      headingText: "InvestorSurvivor",

      subHeading: "Mod",
    },
    {
      imageSrc: incredibleImage3,
      headingText: "BOBSurvivor",

      text: "Web Design",
    },
   
  ];
  return (
    <div className="Incredible" id="team">
      <div className="container">
        <div className="incredibleInfo text-center mb-5">
          <h1 className="sectionHeading">
            <span> TEAM </span>
          </h1>
          <h6>
            Here is the team that is managing this project. We have other team members taking care of our social media,
            marketing, and more.
          </h6>
        </div>
        <div className="row">
          {data.map((item) => (
            <div className="col-md-3 py-md-0 py-3">
              <IncredibleCard data={item} />
            </div>
          ))}
        </div>
        <a href="https://discord.gg/5qneHxqC8a" className="btn mt-5">
          JOIN DISCORD
          <i className="fas fa-chevron-right"></i>
        </a>
      </div>
    </div>
  );
}

export default Incredible;
